import { OfflineStorage } from "./estrylib";
export const LeadPriorities = [
  {
    label: window.sys_app_translate(
      "High",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "High",
  },
  {
    label: window.sys_app_translate(
      "Medium",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "Medium",
  },
  {
    label: window.sys_app_translate(
      "Low",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "Low",
  },
];
export const LeadChannels = [
  {
    label: window.sys_app_translate(
      "Via Whatsapp",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "ViaWhatsapp",
  },
];
export const LeadContacted = [
  {
    label: window.sys_app_translate(
      "No Response",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "NoResponse",
  },
];
